<div class="dashboard-content-sec ">
  <div class="loader" *ngIf="showloader">
    <img src="assets/images/loader.gif" alt="">
  </div>
    <form (ngSubmit)="saveTickets()" [formGroup]="form">
        <div class="row  form-section">
            <div class="mr-auto col-lg-4 col-xl-3 mb-4" *ngIf="curr_user_id.RoleType === 6">
                <div class="card sidecard">
                    <div class="card-form">
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="assignedTo">Assigned To </label>
                          <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.assignedTo.errors }">
                            <select formControlName="assignedTo" name="assignedTo" id="assignedTo" class="form-control">
                              <option value="">Select Assignee</option>
                              <option id="{{assign_user.UserID}}" value="{{assign_user.UserID}}" *ngFor="let assign_user of assignedUser">{{assign_user?.FirstName}} {{assign_user?.LastName}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="submitted && f.assignedTo.errors" class="invalid-feedback">
                        <span *ngIf="f.assignedTo.errors.required">Please Select Assignee</span>
                      </div>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="assignedTo">Client</label>
                                <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }">
                                    <select formControlName="clientId" name="clientId" (change)="getRequester($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }">
                                      <option disabled selected value="">Please select Client</option>
                                      <option id="{{client.ID}}" value="{{client.ID}}" *ngFor="let client of clients">{{client.ClientName}}</option>
                                </select>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.clientId.errors" class="invalid-feedback">
                            <span *ngIf="f.clientId.errors.required">Please Select Client</span>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="requestor">Requestor </label>
                                <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.userId.errors }">
                                    <select formControlName="userId" name="userId" id="requestor" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.userId.errors }">
                                    <option value="{{usr.UserID}}" *ngFor="let usr of users">{{usr?.FirstName}} {{usr?.LastName}}</option>
                                </select>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="submitted && f.userId.errors" class="invalid-feedback">
                            <span *ngIf="f.userId.errors.required">Please Select Requestor</span>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="ticketStatus">Ticket Status</label>
                                <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.statusId.errors }">
                                    <select formControlName="statusId" name="statusId" id="ticketStatus" class="form-control">
                                      <option value="" disabled>Select Status</option>
                                      <option value="1">New</option>
                                      <option value="2">Active</option>
                                      <option value="3">Closed</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.statusId.errors" class="invalid-feedback">
                            <span *ngIf="f.statusId.errors.required">Please Select Status</span>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label>Keywords</label>
                            <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.keyword.errors }">
                              <ng-multiselect-dropdown
                                [placeholder]="'Select Keywords'"
                                [data]="dropdownList"
                                formControlName="keyword" name="keyword"
                                [settings]="dropdownSettings"
                              >
                              </ng-multiselect-dropdown>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="submitted && f.keyword.errors" class="invalid-feedback">
                          <span *ngIf="f.keyword.errors.required">Please Select Keyword</span>
                        </div>

                      <div class="form-row" style="margin-top:15px;">
                        <div class="form-group col-md-12">
                          <label>Agent CC</label>
                          <div class="errorHandler">
                            <ng-multiselect-dropdown
                              [placeholder]="'Select'"
                              [data]="agentCCemailList"
                              formControlName="agentCC" name="agentCC"
                              [settings]="CCdropdownSettings"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                      </div>

                    </div>
                </div>
            </div>

            <!-- right side of display -->
            <div class="col">
                <div class="card">
                    <div class="card-title">
                        <h3><span class="icon-bg"><img src="assets/images/ticket-icon.svg" alt="ticket Icon"></span>New Ticket </h3>
                    </div>
                    <div class="card-form">
                        <div class="form-row">
                            <label class="col-sm-2">Subject Line</label>
                            <div class="form-group col-sm-4 errorHandler" [ngClass]="{ 'is-invalid': submitted && f.subject.errors }">
                                <input formControlName="subject" type="text" class="form-control" id="subject" tabindex="1" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="submitted && f.subject.errors" class="invalid-feedback">
                            <span *ngIf="f.subject.errors.required">Please Add Subject</span>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2">Subject Matter</label>
                            <div class="form-group col-sm-4 errorHandler" [ngClass]="{ 'is-invalid': submitted && f.subjectId.errors }">
                                <select name="subjectId" class="form-control" formControlName="subjectId" tabindex="2">

                                  <option disabled selected value="">Please select Subject Matter</option>

                                  <option *ngFor="let sub of subject" value="{{sub.ID}}">{{sub.Value}}</option>
                                </select>
                            </div>
                            <div *ngIf="submitted && f.subjectId.errors" class="invalid-feedback">
                                <span *ngIf="f.subjectId.errors.required">Please Select Subject Matter</span>
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2 control-label">Does your question pertain to an employee(s)?</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event)" [checked]="empQuestion == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="activeLabel">{{empQuestion}}</label> 
                            </div>
                        </div>


                        <div id="conflict" class="mt-1 form-row collapse" >
                            <label class="col-sm-2 control-label">Employee(s) & Locale</label>
                            <div class="card col d-flex pl-3" style="margin-left: 5px !important;">
                                <div class="user-heading-sec">
                                    <div style='' class="d-inline-block float-left">
                                            <a data-toggle="collapse" href="#newEmpRow" 
                                               class="fa fa-address-book btn btn-default "
                                               style="text-transform: none !important;"
                                               >
                                                Add Employee
                                            </a>                        
                                    </div>       
                        
                                </div>
                        
                                <table id="empTable" class="table-md mt-1">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">City</th>
                                            <th scope="col">State</th >
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        <ng-container *ngFor="let emp of empTable">
                                            <tr id="state-row{{emp.ID}}" class="mb-3">
                                              <td class="pr-1 pb-1">
                                                  <input id="empName{{emp.ID}}" class="form-control"
                                                      value="{{ emp.empName }}" (change)="updateEmp(emp.ID)"/>
                                              </td>
          
                                              <td class="pr-1 pb-1">
                                                  <input id="empCity{{emp.ID}}" class="form-control"
                                                      value="{{ emp.empCity }}" (change)="updateEmp(emp.ID)"/>
                                              </td>
          
                                              <td class="pr-1 pb-1">
                                                  <select id="empState{{emp.ID}}"  class="custom-select" 
                                                         (change)="updateEmp(emp.ID)"> 
                                                      <option value="{{st.ID}}"
                                                          [selected]="st.Code == emp.empState"
                                                          *ngFor="let st of states">{{st?.Code}}                                                                
                                                      </option>
                                                  </select>
                                              </td>
                                                
                                              <td class="pb-1">
                                                  <div class="d-inline-block">
                                                      <a id="del-emp{{emp.ID}}" title="Remove" class="btn fa fa-times"
                                                      (click)="deleteEmp(emp.ID)"> </a>
                                                  </div>
                                              </td>
                                            </tr>
                                        </ng-container>
                                        
                                        <tr class="mt-4" id="newEmpRow">

                                            <td class="pr-1" >
                                                <input id="newEmpName" (change)="checkForAutoSave()"  
                                                       class="form-control new-state"/>
                                            </td>
                                            
                                            <td class="pr-1">
                                                <input id="newEmpCity" (change)="checkForAutoSave()"  
                                                       class="form-control new-state"/>
                                            </td>

                                            <td class="pr-1">
                                                <select id="newEmpState"  (change)="checkForAutoSave()"
                                                    class="custom-select new-state ">
                                                    <option value="{{st.ID}}" 
                                                        *ngFor="let st of states">{{st?.Code}}
                                                    </option>
                                                </select>
                                            </td>
                                            <td class="">
                                                <div class="d-inline-block">
                                                    <a title="Cancel" class="btn fa fa-times" (click)="clearEmp()"> </a>
                                                </div>
                                            </td>
                    
                                        </tr>
                                    </tbody>       
                                </table>
          

                            </div>
                        </div>













                        <!-- <div class="form-row">
                            <label class="col-sm-2">Employee Name</label>
                            <div class="form-group col-sm-3 errorHandler" [ngClass]="{ 'is-invalid': submitted && f.empName.errors }">
                                <input name="empName" class="form-control" formControlName="empName" tabindex="3">
                            </div>
                            <div *ngIf="submitted && f.empName.errors" class="invalid-feedback">
                                <span *ngIf="f.empName.errors.required">Please enter Employee Name</span>
                            </div>

                            <label class="col-sm-1">City</label>
                            <div class="form-group col-sm-3 errorHandler" [ngClass]="{ 'is-invalid': submitted && f.empCity.errors }">
                                <input name="empCity" class="form-control" formControlName="empCity" tabindex="4">
                            </div>
                            <div *ngIf="submitted && f.empCity.errors" class="invalid-feedback">
                                <span *ngIf="f.empCity.errors.required">Please enter Employee City</span>
                            </div>

                            <label class="col-sm-1 ml-3">State</label>
                            <div class="form-group col-sm-2 errorHandler" [ngClass]="{ 'is-invalid': submitted && f.empState.errors }">
                                <ng-multiselect-dropdown tabindex="5"
                                  [placeholder]="'Select'" [data]="states"
                                  formControlName="empState" name="empState" id="empState"
                                  [settings]="StatedropdownSettings">
                                </ng-multiselect-dropdown>
  
                            </div>
                            <div *ngIf="submitted && f.empState.errors" class="invalid-feedback">
                                <span *ngIf="f.empState.errors.required">Please enter Employee State</span>
                            </div>
                        </div>

 -->
                         <div class="form-row mb-3">
                              <label class="col-sm-2">CC</label>
                              <div class="form-group col-sm-4">
                                  <ng-multiselect-dropdown tabindex="6"
                                    [placeholder]="'Select'" [data]="CCemailList"
                                    formControlName="clientCC" name="clientCC" id="clientCC"
                                    [settings]="CCdropdownSettings">
                                  </ng-multiselect-dropdown>
                              </div>
                        </div>
             
                        <!-- <label for="inputCity">Question?</label>
                        <div class="form-row textarea">
                            <div class="errorHandler custom-upload" style="min-height:300px"
                                [ngClass]="{ 'is-invalid': submitted }">
                                <ngb-tabset>
                                    <ngb-tab>
                                        <ng-template ngbTabTitle><i class="fa fa-text-height" tabindex="5"></i></ng-template>
                                        <ng-template ngbTabContent>
                                            <div id="response" ></div>
                                        </ng-template>

                                    </ngb-tab>

                                    <ngb-tab>
                                        <ng-template ngbTabTitle><i class="fa fa-paperclip" tabindex="6"></i></ng-template>
                                        <ng-template ngbTabContent>
                                            <input name="imageInput" (change)="getFiles($event)" type="file" multiple />
                                            <button type="button" class="btn btn-default align-items-end">Choose File</button><i>{{custom_image_title}}</i>
                                        </ng-template>
                                    </ngb-tab>
                                </ngb-tabset>

                            </div>
                        </div> -->

                        <div class="form-row mb-10">
                          <div class="form-group col-sm-12">
                             <div class="form-row textarea" style="border: none">
                                 <div class="errorHandler custom-upload mb-2" style="padding: 5px;">
                                   <div id="response" [froalaEditor]="options" [(froalaModel)]="replyContent"></div>
                                 </div>
                             </div>
                          </div>
                        </div>                        

                        <div class="form-row mb-10">
                          <label>Attach files. Use Ctrl+click to select multiple files.</label>
                        </div>
                        <div class="form-row">
                            <!-- <input name="fileInput" class="filestyle btn btn-default btn-outline-primary" 
                              (change)="getFiles($event)" type="file" multiple
                              data-buttonText="hellow" /> -->
                            
                            <input type="button" class="btn btn-default" value="Choose File(s)" onclick="document.getElementById('file').click();" />
                            <input type="file" style="display:none;" id="file" 
                                   (change)="getFiles($event)"                       
                                   name="file" multiple/>
                        </div>
                        <div>
                          <span>{{custom_image_title}}</span>
                            <!-- <button type="button" class="btn btn-default btn-outline-primary align-items-end">Choose File</button><span>{{custom_image_title}}</span> -->
                        </div>

                        <div *ngIf="submitted && show_error==true" class="invalid-feedback">
                            <span >Please Type Your Question</span></div>
                        <div *ngIf="submitted && f.imageInput.errors" class="invalid-feedback">
                            <span *ngIf="f.imageInput.errors.required">Please Add Attachment</span>
                        </div>
                        <button type="submit" class="btn btn-default align-items-end" tabindex="7">Submit</button>
                    </div>
                    <div class="tc">
                        <span class="">*By clicking submit, you agree to the
                          <a class="tc-a" target="_blank" href="https://myhrcounsel.com/terms/">Terms and Conditions</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
